import React, { useEffect, useState } from 'react';

import ReactDOM from 'react-dom';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import Button from 'components/shared/Button';
import Icon from 'components/shared/Icon';
import Lock from 'components/shared/Icon/icons/Lock';
import { getPath, SETTINGS_SUBS_PATH } from 'constants/routes';
import { currentAccountSelector, isAccountOwnerSelector } from 'store/user/selectors';
import { confirmAlert } from 'utils/alert';

const WRAPPER_STYLES = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'rgba(241, 241, 241, 0.8)',
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  textAlign: 'center',
};
const INNER_STYLES = {
  width: '17em',
};
const BLOCKER_STYLES = {
  marginBottom: '1.1em',
};
const TEXT_STYLES = {
  fontFamily: 'var(--font_family-accent)',
  fontSize: '1em',
  lineHeight: '1em',
};
const TEXT_HEADER_STYLES = {
  fontWeight: '700',
};

export function Blocker({
  selector,
  size,
  iconSize = size,
  title = 'Content Locked!',
  text,
  offsetCompensation,
  page,
  children,
  innerDisabled,
  bottom,
  titleDisabled,
  zIndex = 1001,
  wrapperStyles = {},
  innerStyles = {},
  textStyles = {},
}) {
  const [ref, setRef] = useState();

  useEffect(() => {
    if (selector) {
      setRef(document.querySelector(selector));
    }
  }, [selector]);

  const style = {
    ...WRAPPER_STYLES,
    zIndex,
    fontSize: size,
    marginLeft: `calc(${offsetCompensation} * -1)`,
    marginRight: `calc(${offsetCompensation} * -1)`,
    ...wrapperStyles,
  };

  if (bottom) {
    style.bottom = bottom;
  }

  const iconStyles = titleDisabled ? {} : { ...BLOCKER_STYLES };

  if (iconSize) {
    iconStyles.fontSize = iconSize;
  }

  const inner = (
    <div style={{ ...INNER_STYLES, ...innerStyles }}>
      <div style={iconStyles}>
        <Icon component={Lock} height="1.5em" width="1.13em" style={{ verticalAlign: 'top' }} />
      </div>
      {!titleDisabled && (
        <div style={{ ...TEXT_STYLES, ...textStyles }}>
          <div style={TEXT_HEADER_STYLES}>{title}</div>
          {Boolean(text) && (
            <>
              <br />
              <div>{text}</div>
              <br />
            </>
          )}
        </div>
      )}
      <div>
        {Boolean(children) && <div style={{ marginRight: page ? '1rem' : 0, display: 'inline-block' }}>{children}</div>}
      </div>
    </div>
  );

  const element = <div style={style}>{!innerDisabled && inner}</div>;

  if (ref) {
    return ReactDOM.createPortal(element, ref);
  }

  return element;
}

export const BlockerForAgent = ({ anchor, buttonProps = {}, ...props }) => {
  const isAccountOwner = useSelector(isAccountOwnerSelector);
  const history = useHistory();
  const currentAccount = useSelector(currentAccountSelector);

  const upgrade = () => {
    if (isAccountOwner) {
      let url = getPath(SETTINGS_SUBS_PATH, { accountId: currentAccount.id });
      if (anchor) url += '#' + anchor;
      history.push(`${url}`);
    } else {
      confirmAlert({
        title: 'Upgrade Your Account to Proceed',
        confirmButtonText: 'Contact Admin',
        hintBottom: 'Please contact your Account Administrator to upgrade your subscription plan.',
        showCancel: false,
        onConfirm: () => window.open(`mailto:${currentAccount.accountOwnerEmail}`),
      });
    }
  };

  return (
    <Blocker
      size="23px"
      text="Please upgrade your plan to unlock this section."
      children={<Button children="Upgrade" onClick={upgrade} {...buttonProps} />}
      {...props}
    />
  );
};
